import { call, put } from "redux-saga/effects";

import {
  requestPlaceCall,
  requestGetCallStatus,
  requestEndCall,
  requestGetRecording,
  requestGetJobs,
  requestGetDoctorLogs,
  requestGetBillingLogs,
  requestImportCall,
  requestGetTranscript,
} from "../requests/aiVerificationCall";

import {
  setLoaderState,
  setCallResult,
  setJobs,
  setDoctorLogs,
  setBillingLogs,
  setTranscript,
  setRecordingUrl,
} from "../../ducks/aiVerificationCall";

import { setUserAuthentication, setUserForbidden } from "../../ducks/auth";

import { Authentication } from "../../../utils/authentication";

function* handleAuthError(error) {
  if (error?.response?.status === 401) {
    yield put(setUserAuthentication(false));
    Authentication();
  }
  if (error?.response?.status === 403) {
    yield put(setUserForbidden(true));
  }
}

export function* handlePlaceCall(action) {
  try {
    yield put(setLoaderState(true));
    const response = yield call(requestPlaceCall, action.payload);
    const { data } = response;
    yield put(setCallResult(data.item));
    yield put(setLoaderState(false));
  } catch (error) {
    yield put(setLoaderState(false));
    yield* handleAuthError(error);
  }
}

export function* handleGetCallStatus(action) {
  try {
    const response = yield call(requestGetCallStatus, action.payload);
    const { data } = response;
    yield put(setCallResult(data.item));
  } catch (error) {
    yield* handleAuthError(error);
  }
}

export function* handleEndCall(action) {
  try {
    yield put(setLoaderState(true));
    const response = yield call(requestEndCall, action.payload);
    const { data } = response;
    yield put(setCallResult(data.item));
    yield put(setLoaderState(false));
  } catch (error) {
    yield put(setLoaderState(false));
    yield* handleAuthError(error);
  }
}

export function* handleGetRecording(action) {
  try {
    const response = yield call(requestGetRecording, action.payload);
    const url = URL.createObjectURL(response.data);
    yield put(setRecordingUrl({ jobId: action.payload, url }));
  } catch (error) {
    yield* handleAuthError(error);
  }
}

export function* handleGetJobs() {
  try {
    yield put(setLoaderState(true));
    const response = yield call(requestGetJobs);
    const { data } = response;
    yield put(setJobs(data.items || []));
    yield put(setLoaderState(false));
  } catch (error) {
    yield put(setLoaderState(false));
    yield put(setJobs([]));
    yield* handleAuthError(error);
  }
}

export function* handleGetDoctorLogs(action) {
  try {
    yield put(setLoaderState(true));
    const response = yield call(requestGetDoctorLogs, action.payload);
    const { data } = response;
    yield put(
      setDoctorLogs({ phoneNumber: action.payload, items: data.items || [] })
    );
    yield put(setLoaderState(false));
  } catch (error) {
    yield put(setLoaderState(false));
    yield put(setDoctorLogs({ phoneNumber: action.payload, items: [] }));
    yield* handleAuthError(error);
  }
}

export function* handleGetBillingLogs() {
  try {
    yield put(setLoaderState(true));
    const response = yield call(requestGetBillingLogs);
    const { data } = response;
    yield put(setBillingLogs(data.items || []));
    yield put(setLoaderState(false));
  } catch (error) {
    yield put(setLoaderState(false));
    yield put(setBillingLogs([]));
    yield* handleAuthError(error);
  }
}

export function* handleImportCall(action) {
  try {
    yield put(setLoaderState(true));
    const response = yield call(requestImportCall, action.payload);
    const { data } = response;
    yield put(setCallResult(data.item));
    yield put(setLoaderState(false));
  } catch (error) {
    yield put(setLoaderState(false));
    yield* handleAuthError(error);
  }
}

export function* handleGetTranscript(action) {
  try {
    const response = yield call(requestGetTranscript, action.payload);
    const item = response?.data?.item;
    if (item) {
      yield put(
        setTranscript({
          jobId: item.jobId,
          fullTranscript: item.fullTranscript,
          dtmfPresses: item.dtmfPresses || [],
        })
      );
    }
  } catch (error) {
    yield* handleAuthError(error);
  }
}
